module.exports = __webpack_public_path__ + "static/media/mgm_interior2.7a4301a8.jpg";